document.addEventListener("DOMContentLoaded", function () {
  const root = document.querySelector(".testimonial-wrapper");
  if (!root) return;

  const track    = root.querySelector("#testimonial-carousel");
  const prevBtn  = root.querySelector("#prev-btn");
  const nextBtn  = root.querySelector("#next-btn");

  // Settings (data attributes set in Liquid)
  const autoplay    = root.dataset.autoplay === "true";
  const speed       = parseInt(root.dataset.speed, 10) || 3000;
  const loopSetting = root.dataset.loop === "true";          // loop *only* used for autoplay restart, not for button wrap
  const pauseHover  = root.dataset.pauseHover === "true";

  const GAP = 28; // must match CSS gap between cards

  function firstCard() {
    return track.querySelector(".testimonial-card");
  }

  function cardStep() {
    const first = firstCard();
    return first ? first.getBoundingClientRect().width + GAP : 360;
  }

  function atStart() {
    return track.scrollLeft <= 2;
  }

  function atEnd() {
    return (track.scrollLeft + track.clientWidth) >= (track.scrollWidth - 2);
  }

  function updateBtns() {
    prevBtn.disabled = atStart();
    nextBtn.disabled = atEnd();
  }

  function scrollByDir(dir) {
    track.scrollBy({ left: dir * cardStep(), behavior: "smooth" });
    // update buttons after the scroll animation roughly ends
    setTimeout(updateBtns, 350);
  }

  // Button events (NO wrapping)
  prevBtn.addEventListener("click", () => {
    if (!atStart()) scrollByDir(-1);
  });

  nextBtn.addEventListener("click", () => {
    if (!atEnd()) scrollByDir(1);
  });

  // Autoplay
  let intervalId = null;

  function startAutoplay() {
    if (!autoplay) return;
    stopAutoplay();
    intervalId = setInterval(() => {
      if (atEnd()) {
        if (loopSetting) {
          // Restart from beginning (remove / comment to STOP at last card)
          track.scrollTo({ left: 0, behavior: "smooth" });
          setTimeout(updateBtns, 400);
        } else {
          // Stop autoplay if no loop
          stopAutoplay();
        }
      } else {
        nextBtn.click();
      }
    }, speed);
  }

  function stopAutoplay() {
    if (intervalId) clearInterval(intervalId);
    intervalId = null;
  }

  if (pauseHover) {
    root.addEventListener("mouseenter", stopAutoplay);
    root.addEventListener("mouseleave", startAutoplay);
  }

  // Pause while user focuses inside
  root.addEventListener("focusin", stopAutoplay);
  root.addEventListener("focusout", () => {
    // resume only if not at end or if looping
    if (!atEnd() || loopSetting) startAutoplay();
  });

  // Snap refine after manual scroll
  let scrollTimer;
  track.addEventListener("scroll", () => {
    updateBtns();
    if (scrollTimer) clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
      const step = cardStep();
      const index = Math.round(track.scrollLeft / step);
      track.scrollTo({ left: index * step, behavior: "smooth" });
    }, 160);
  }, { passive: true });

  // Keyboard support (left/right when carousel focused)
  track.addEventListener("keydown", e => {
    if (e.key === "ArrowRight") {
      e.preventDefault();
      nextBtn.click();
    } else if (e.key === "ArrowLeft") {
      e.preventDefault();
      prevBtn.click();
    }
  });

  // Make track focusable if not already
  if (!track.hasAttribute("tabindex")) {
    track.setAttribute("tabindex", "0");
  }

  updateBtns();
  startAutoplay();
});
